export default __webpack_public_path__ + "static/nexusmods-icon-66d4eb7d17aea9ba3329f3d7a1291f03.png";